import { labelDefaultMediumStyles, labelDefaultRegularStyles } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['05']};
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['03']};
`

export const FieldLabel = styled.span`
  ${labelDefaultMediumStyles}
  color: ${({ theme }) => theme.color.content.main as string};
`

/** Sets the confirmation apart from the member field so it reads as a deliberate extra step. */
export const ReviewConfirmation = styled.div`
  background: ${({ theme }) => theme.color.background.highlight as string};
  border-radius: ${({ theme }) => theme.size.border.radius['03']};
  padding: ${({ theme }) => theme.size.space['05']};
`

export const ReviewConfirmationHint = styled.p`
  ${labelDefaultRegularStyles}
  color: ${({ theme }) => theme.color.content.secondary as string};
  margin: ${({ theme }) => theme.size.space['02']} 0 0
    calc(${({ theme }) => theme.size.icon.small} + ${({ theme }) => theme.size.space['03']});
`
